/**
 * FEEDBACK WIDGET — INSTALLATION PRÉCOCE DU NETWORK TRACKER (TICKET-CRM-14)
 * Module side-effect importé EN PREMIER dans main.tsx : supabase-js capture
 * le fetch global à la création du client (import de src/lib/supabase.ts).
 * Si le wrapper n'est pas posé avant, les appels Supabase — précisément ceux
 * qu'on veut dans le snapshot debug — ne sont jamais tracés.
 */

import { networkTracker } from './network-tracker';

networkTracker.initialize();
